'use client';

import { Typography } from '@curology/ui-components-web/react/Typography';
import React from 'react';

import { useDataProvider } from '@/components/flow/components/DataProvider/useDataProvider';
import { DATA_KEYS } from '@/consts/dataKeys';

export function ProductSelectionHeader() {
  const {
    patient: { firstname },
  } = useDataProvider(DATA_KEYS.productSelection);

  return (
    <Typography size="h1">
      {firstname
        ? `${firstname}'s recommended routine`
        : 'Your recommended routine'}
    </Typography>
  );
}
